// extracted by mini-css-extract-plugin
module.exports = {"brandsList":"BrandsUnderline_brandsList__E2mCw","brandsListUnderline":"BrandsUnderline_brandsListUnderline__ibr5Y"};